import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

export const reportError = createAction<{
  message: string;
  error: AxiosError | Record<string, any> | unknown;
  additionalData?: Record<string, any>;
  ignoreNetwork?: boolean;
}>('reportError');
